export default __webpack_public_path__ + "968405ed6e865c94539cbba72a8b11aa.png";